import { useContext } from 'react'
import { AuthContext, Dialog } from 'alurkerja-ui'
import { env } from '@/utils/constants/env'
import { useMutation } from '@tanstack/react-query'

interface IQuotaAvailability {
  timeOffId: number
  employeeId: number
}

interface IQuotaAvailabilityResponse {
  number_of_days: number
  number_of_hours: number
}

const useGetQuotaAvailabilityApi = () => {
  const axios = useContext(AuthContext)
  axios.defaults.baseURL = env.apiBaseUrl

  return async (data: IQuotaAvailability) => {
    try {
      const response = await axios.get('/api/v1/odoo/leave-quota', {
        params: {
          leave_id: data.timeOffId,
          employee_id: data.employeeId,
        },
      })

      return response.data.data as IQuotaAvailabilityResponse
    } catch (error: any) {
      Dialog.error({
        title: 'Error',
        description: error.response.data.message || 'Failed to fetch quota availability. Please try again later.',
      })
    }
  }
}

export const useGetQuotaAvailability = () => {
  const getQuotaAvailability = useGetQuotaAvailabilityApi()

  return useMutation((data: IQuotaAvailability) => getQuotaAvailability(data))
}